/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BancoDeTemasRouteRouteImport } from './routes/banco-de-temas/route'
import { Route as HomeRouteRouteImport } from './routes/home/route'
import { Route as MicrodadosRouteRouteImport } from './routes/microdados/route'
import { Route as RedacoesRouteRouteImport } from './routes/redacoes/route'
import { Route as RednewsRouteImport } from './routes/rednews'
import { Route as TrilhaDeAprendizagemRouteRouteImport } from './routes/trilha-de-aprendizagem/route'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as BancoDeTemasIndexRouteImport } from './routes/banco-de-temas/index'
import { Route as BancoDeTemasColecoesRouteImport } from './routes/banco-de-temas/colecoes'
import { Route as BancoDeTemasMeusTemasRouteImport } from './routes/banco-de-temas/meus-temas'
import { Route as BancoDeTemasSalvosRouteImport } from './routes/banco-de-temas/salvos'
import { Route as HomeCoordenadorRouteImport } from './routes/home/coordenador'
import { Route as MicrodadosIndexRouteImport } from './routes/microdados/index'
import { Route as MicrodadosAnaliseDetalhadaRouteImport } from './routes/microdados/analise-detalhada'
import { Route as MicrodadosPdfPreviewRouteImport } from './routes/microdados/pdf-preview'
import { Route as PagamentoIndexRouteImport } from './routes/pagamento/index'
import { Route as RedacoesIndexRouteImport } from './routes/redacoes/index'
import { Route as RedacoesTrilhaDeAprendizagemRouteImport } from './routes/redacoes/trilha-de-aprendizagem'
import { Route as ResultadosIndexRouteImport } from './routes/resultados/index'
import { Route as TarefaNovaRouteImport } from './routes/tarefa/nova'
import { Route as TrilhaDeAprendizagemIdRouteImport } from './routes/trilha-de-aprendizagem/$id'
import { Route as TrilhaDeAprendizagemNovaRouteImport } from './routes/trilha-de-aprendizagem/nova'
import { Route as BancoDeTemasColecoesIdRouteImport } from './routes/banco-de-temas/colecoes_.$id'
import { Route as ResultadosAlunoIndexRouteImport } from './routes/resultados/aluno/index'
import { Route as TarefaIdTarefaVisaoGeralRouteImport } from './routes/tarefa/$idTarefa/visao-geral'
import { Route as TrilhaDeAprendizagemEditarIdRouteImport } from './routes/trilha-de-aprendizagem/editar/$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BancoDeTemasRouteRoute = BancoDeTemasRouteRouteImport.update({
  id: '/banco-de-temas',
  path: '/banco-de-temas',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRouteRoute = HomeRouteRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const MicrodadosRouteRoute = MicrodadosRouteRouteImport.update({
  id: '/microdados',
  path: '/microdados',
  getParentRoute: () => rootRouteImport,
} as any)
const RedacoesRouteRoute = RedacoesRouteRouteImport.update({
  id: '/redacoes',
  path: '/redacoes',
  getParentRoute: () => rootRouteImport,
} as any)
const RednewsRoute = RednewsRouteImport.update({
  id: '/rednews',
  path: '/rednews',
  getParentRoute: () => rootRouteImport,
} as any)
const TrilhaDeAprendizagemRouteRoute =
  TrilhaDeAprendizagemRouteRouteImport.update({
    id: '/trilha-de-aprendizagem',
    path: '/trilha-de-aprendizagem',
    getParentRoute: () => rootRouteImport,
  } as any)
const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const BancoDeTemasIndexRoute = BancoDeTemasIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BancoDeTemasRouteRoute,
} as any)
const BancoDeTemasColecoesRoute = BancoDeTemasColecoesRouteImport.update({
  id: '/colecoes',
  path: '/colecoes',
  getParentRoute: () => BancoDeTemasRouteRoute,
} as any)
const BancoDeTemasMeusTemasRoute = BancoDeTemasMeusTemasRouteImport.update({
  id: '/meus-temas',
  path: '/meus-temas',
  getParentRoute: () => BancoDeTemasRouteRoute,
} as any)
const BancoDeTemasSalvosRoute = BancoDeTemasSalvosRouteImport.update({
  id: '/salvos',
  path: '/salvos',
  getParentRoute: () => BancoDeTemasRouteRoute,
} as any)
const HomeCoordenadorRoute = HomeCoordenadorRouteImport.update({
  id: '/coordenador',
  path: '/coordenador',
  getParentRoute: () => HomeRouteRoute,
} as any)
const MicrodadosIndexRoute = MicrodadosIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MicrodadosRouteRoute,
} as any)
const MicrodadosAnaliseDetalhadaRoute =
  MicrodadosAnaliseDetalhadaRouteImport.update({
    id: '/analise-detalhada',
    path: '/analise-detalhada',
    getParentRoute: () => MicrodadosRouteRoute,
  } as any)
const MicrodadosPdfPreviewRoute = MicrodadosPdfPreviewRouteImport.update({
  id: '/pdf-preview',
  path: '/pdf-preview',
  getParentRoute: () => MicrodadosRouteRoute,
} as any)
const PagamentoIndexRoute = PagamentoIndexRouteImport.update({
  id: '/pagamento/',
  path: '/pagamento/',
  getParentRoute: () => rootRouteImport,
} as any)
const RedacoesIndexRoute = RedacoesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RedacoesRouteRoute,
} as any)
const RedacoesTrilhaDeAprendizagemRoute =
  RedacoesTrilhaDeAprendizagemRouteImport.update({
    id: '/trilha-de-aprendizagem',
    path: '/trilha-de-aprendizagem',
    getParentRoute: () => RedacoesRouteRoute,
  } as any)
const ResultadosIndexRoute = ResultadosIndexRouteImport.update({
  id: '/resultados/',
  path: '/resultados/',
  getParentRoute: () => rootRouteImport,
} as any)
const TarefaNovaRoute = TarefaNovaRouteImport.update({
  id: '/tarefa/nova',
  path: '/tarefa/nova',
  getParentRoute: () => rootRouteImport,
} as any)
const TrilhaDeAprendizagemIdRoute = TrilhaDeAprendizagemIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => TrilhaDeAprendizagemRouteRoute,
} as any)
const TrilhaDeAprendizagemNovaRoute =
  TrilhaDeAprendizagemNovaRouteImport.update({
    id: '/nova',
    path: '/nova',
    getParentRoute: () => TrilhaDeAprendizagemRouteRoute,
  } as any)
const BancoDeTemasColecoesIdRoute = BancoDeTemasColecoesIdRouteImport.update({
  id: '/colecoes_/$id',
  path: '/colecoes/$id',
  getParentRoute: () => BancoDeTemasRouteRoute,
} as any)
const ResultadosAlunoIndexRoute = ResultadosAlunoIndexRouteImport.update({
  id: '/resultados/aluno/',
  path: '/resultados/aluno/',
  getParentRoute: () => rootRouteImport,
} as any)
const TarefaIdTarefaVisaoGeralRoute =
  TarefaIdTarefaVisaoGeralRouteImport.update({
    id: '/tarefa/$idTarefa/visao-geral',
    path: '/tarefa/$idTarefa/visao-geral',
    getParentRoute: () => rootRouteImport,
  } as any)
const TrilhaDeAprendizagemEditarIdRoute =
  TrilhaDeAprendizagemEditarIdRouteImport.update({
    id: '/editar/$id',
    path: '/editar/$id',
    getParentRoute: () => TrilhaDeAprendizagemRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/banco-de-temas': typeof BancoDeTemasRouteRouteWithChildren
  '/home': typeof HomeRouteRouteWithChildren
  '/microdados': typeof MicrodadosRouteRouteWithChildren
  '/redacoes': typeof RedacoesRouteRouteWithChildren
  '/trilha-de-aprendizagem': typeof TrilhaDeAprendizagemRouteRouteWithChildren
  '/rednews': typeof RednewsRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/banco-de-temas/colecoes': typeof BancoDeTemasColecoesRoute
  '/banco-de-temas/meus-temas': typeof BancoDeTemasMeusTemasRoute
  '/banco-de-temas/salvos': typeof BancoDeTemasSalvosRoute
  '/home/coordenador': typeof HomeCoordenadorRoute
  '/microdados/analise-detalhada': typeof MicrodadosAnaliseDetalhadaRoute
  '/microdados/pdf-preview': typeof MicrodadosPdfPreviewRoute
  '/redacoes/trilha-de-aprendizagem': typeof RedacoesTrilhaDeAprendizagemRoute
  '/tarefa/nova': typeof TarefaNovaRoute
  '/trilha-de-aprendizagem/$id': typeof TrilhaDeAprendizagemIdRoute
  '/trilha-de-aprendizagem/nova': typeof TrilhaDeAprendizagemNovaRoute
  '/banco-de-temas/': typeof BancoDeTemasIndexRoute
  '/microdados/': typeof MicrodadosIndexRoute
  '/pagamento/': typeof PagamentoIndexRoute
  '/redacoes/': typeof RedacoesIndexRoute
  '/resultados/': typeof ResultadosIndexRoute
  '/banco-de-temas/colecoes/$id': typeof BancoDeTemasColecoesIdRoute
  '/tarefa/$idTarefa/visao-geral': typeof TarefaIdTarefaVisaoGeralRoute
  '/trilha-de-aprendizagem/editar/$id': typeof TrilhaDeAprendizagemEditarIdRoute
  '/resultados/aluno/': typeof ResultadosAlunoIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/home': typeof HomeRouteRouteWithChildren
  '/trilha-de-aprendizagem': typeof TrilhaDeAprendizagemRouteRouteWithChildren
  '/rednews': typeof RednewsRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/banco-de-temas/colecoes': typeof BancoDeTemasColecoesRoute
  '/banco-de-temas/meus-temas': typeof BancoDeTemasMeusTemasRoute
  '/banco-de-temas/salvos': typeof BancoDeTemasSalvosRoute
  '/home/coordenador': typeof HomeCoordenadorRoute
  '/microdados/analise-detalhada': typeof MicrodadosAnaliseDetalhadaRoute
  '/microdados/pdf-preview': typeof MicrodadosPdfPreviewRoute
  '/redacoes/trilha-de-aprendizagem': typeof RedacoesTrilhaDeAprendizagemRoute
  '/tarefa/nova': typeof TarefaNovaRoute
  '/trilha-de-aprendizagem/$id': typeof TrilhaDeAprendizagemIdRoute
  '/trilha-de-aprendizagem/nova': typeof TrilhaDeAprendizagemNovaRoute
  '/banco-de-temas': typeof BancoDeTemasIndexRoute
  '/microdados': typeof MicrodadosIndexRoute
  '/pagamento': typeof PagamentoIndexRoute
  '/redacoes': typeof RedacoesIndexRoute
  '/resultados': typeof ResultadosIndexRoute
  '/banco-de-temas/colecoes/$id': typeof BancoDeTemasColecoesIdRoute
  '/tarefa/$idTarefa/visao-geral': typeof TarefaIdTarefaVisaoGeralRoute
  '/trilha-de-aprendizagem/editar/$id': typeof TrilhaDeAprendizagemEditarIdRoute
  '/resultados/aluno': typeof ResultadosAlunoIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/banco-de-temas': typeof BancoDeTemasRouteRouteWithChildren
  '/home': typeof HomeRouteRouteWithChildren
  '/microdados': typeof MicrodadosRouteRouteWithChildren
  '/redacoes': typeof RedacoesRouteRouteWithChildren
  '/trilha-de-aprendizagem': typeof TrilhaDeAprendizagemRouteRouteWithChildren
  '/rednews': typeof RednewsRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/banco-de-temas/colecoes': typeof BancoDeTemasColecoesRoute
  '/banco-de-temas/meus-temas': typeof BancoDeTemasMeusTemasRoute
  '/banco-de-temas/salvos': typeof BancoDeTemasSalvosRoute
  '/home/coordenador': typeof HomeCoordenadorRoute
  '/microdados/analise-detalhada': typeof MicrodadosAnaliseDetalhadaRoute
  '/microdados/pdf-preview': typeof MicrodadosPdfPreviewRoute
  '/redacoes/trilha-de-aprendizagem': typeof RedacoesTrilhaDeAprendizagemRoute
  '/tarefa/nova': typeof TarefaNovaRoute
  '/trilha-de-aprendizagem/$id': typeof TrilhaDeAprendizagemIdRoute
  '/trilha-de-aprendizagem/nova': typeof TrilhaDeAprendizagemNovaRoute
  '/banco-de-temas/': typeof BancoDeTemasIndexRoute
  '/microdados/': typeof MicrodadosIndexRoute
  '/pagamento/': typeof PagamentoIndexRoute
  '/redacoes/': typeof RedacoesIndexRoute
  '/resultados/': typeof ResultadosIndexRoute
  '/banco-de-temas/colecoes_/$id': typeof BancoDeTemasColecoesIdRoute
  '/tarefa/$idTarefa/visao-geral': typeof TarefaIdTarefaVisaoGeralRoute
  '/trilha-de-aprendizagem/editar/$id': typeof TrilhaDeAprendizagemEditarIdRoute
  '/resultados/aluno/': typeof ResultadosAlunoIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/banco-de-temas'
    | '/home'
    | '/microdados'
    | '/redacoes'
    | '/trilha-de-aprendizagem'
    | '/rednews'
    | '/unauthorized'
    | '/banco-de-temas/colecoes'
    | '/banco-de-temas/meus-temas'
    | '/banco-de-temas/salvos'
    | '/home/coordenador'
    | '/microdados/analise-detalhada'
    | '/microdados/pdf-preview'
    | '/redacoes/trilha-de-aprendizagem'
    | '/tarefa/nova'
    | '/trilha-de-aprendizagem/$id'
    | '/trilha-de-aprendizagem/nova'
    | '/banco-de-temas/'
    | '/microdados/'
    | '/pagamento/'
    | '/redacoes/'
    | '/resultados/'
    | '/banco-de-temas/colecoes/$id'
    | '/tarefa/$idTarefa/visao-geral'
    | '/trilha-de-aprendizagem/editar/$id'
    | '/resultados/aluno/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/home'
    | '/trilha-de-aprendizagem'
    | '/rednews'
    | '/unauthorized'
    | '/banco-de-temas/colecoes'
    | '/banco-de-temas/meus-temas'
    | '/banco-de-temas/salvos'
    | '/home/coordenador'
    | '/microdados/analise-detalhada'
    | '/microdados/pdf-preview'
    | '/redacoes/trilha-de-aprendizagem'
    | '/tarefa/nova'
    | '/trilha-de-aprendizagem/$id'
    | '/trilha-de-aprendizagem/nova'
    | '/banco-de-temas'
    | '/microdados'
    | '/pagamento'
    | '/redacoes'
    | '/resultados'
    | '/banco-de-temas/colecoes/$id'
    | '/tarefa/$idTarefa/visao-geral'
    | '/trilha-de-aprendizagem/editar/$id'
    | '/resultados/aluno'
  id:
    | '__root__'
    | '/'
    | '/banco-de-temas'
    | '/home'
    | '/microdados'
    | '/redacoes'
    | '/trilha-de-aprendizagem'
    | '/rednews'
    | '/unauthorized'
    | '/banco-de-temas/colecoes'
    | '/banco-de-temas/meus-temas'
    | '/banco-de-temas/salvos'
    | '/home/coordenador'
    | '/microdados/analise-detalhada'
    | '/microdados/pdf-preview'
    | '/redacoes/trilha-de-aprendizagem'
    | '/tarefa/nova'
    | '/trilha-de-aprendizagem/$id'
    | '/trilha-de-aprendizagem/nova'
    | '/banco-de-temas/'
    | '/microdados/'
    | '/pagamento/'
    | '/redacoes/'
    | '/resultados/'
    | '/banco-de-temas/colecoes_/$id'
    | '/tarefa/$idTarefa/visao-geral'
    | '/trilha-de-aprendizagem/editar/$id'
    | '/resultados/aluno/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BancoDeTemasRouteRoute: typeof BancoDeTemasRouteRouteWithChildren
  HomeRouteRoute: typeof HomeRouteRouteWithChildren
  MicrodadosRouteRoute: typeof MicrodadosRouteRouteWithChildren
  RedacoesRouteRoute: typeof RedacoesRouteRouteWithChildren
  TrilhaDeAprendizagemRouteRoute: typeof TrilhaDeAprendizagemRouteRouteWithChildren
  RednewsRoute: typeof RednewsRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
  TarefaNovaRoute: typeof TarefaNovaRoute
  PagamentoIndexRoute: typeof PagamentoIndexRoute
  ResultadosIndexRoute: typeof ResultadosIndexRoute
  TarefaIdTarefaVisaoGeralRoute: typeof TarefaIdTarefaVisaoGeralRoute
  ResultadosAlunoIndexRoute: typeof ResultadosAlunoIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/banco-de-temas': {
      id: '/banco-de-temas'
      path: '/banco-de-temas'
      fullPath: '/banco-de-temas'
      preLoaderRoute: typeof BancoDeTemasRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/microdados': {
      id: '/microdados'
      path: '/microdados'
      fullPath: '/microdados'
      preLoaderRoute: typeof MicrodadosRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/redacoes': {
      id: '/redacoes'
      path: '/redacoes'
      fullPath: '/redacoes'
      preLoaderRoute: typeof RedacoesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rednews': {
      id: '/rednews'
      path: '/rednews'
      fullPath: '/rednews'
      preLoaderRoute: typeof RednewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trilha-de-aprendizagem': {
      id: '/trilha-de-aprendizagem'
      path: '/trilha-de-aprendizagem'
      fullPath: '/trilha-de-aprendizagem'
      preLoaderRoute: typeof TrilhaDeAprendizagemRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/banco-de-temas/': {
      id: '/banco-de-temas/'
      path: '/'
      fullPath: '/banco-de-temas/'
      preLoaderRoute: typeof BancoDeTemasIndexRouteImport
      parentRoute: typeof BancoDeTemasRouteRoute
    }
    '/banco-de-temas/colecoes': {
      id: '/banco-de-temas/colecoes'
      path: '/colecoes'
      fullPath: '/banco-de-temas/colecoes'
      preLoaderRoute: typeof BancoDeTemasColecoesRouteImport
      parentRoute: typeof BancoDeTemasRouteRoute
    }
    '/banco-de-temas/meus-temas': {
      id: '/banco-de-temas/meus-temas'
      path: '/meus-temas'
      fullPath: '/banco-de-temas/meus-temas'
      preLoaderRoute: typeof BancoDeTemasMeusTemasRouteImport
      parentRoute: typeof BancoDeTemasRouteRoute
    }
    '/banco-de-temas/salvos': {
      id: '/banco-de-temas/salvos'
      path: '/salvos'
      fullPath: '/banco-de-temas/salvos'
      preLoaderRoute: typeof BancoDeTemasSalvosRouteImport
      parentRoute: typeof BancoDeTemasRouteRoute
    }
    '/home/coordenador': {
      id: '/home/coordenador'
      path: '/coordenador'
      fullPath: '/home/coordenador'
      preLoaderRoute: typeof HomeCoordenadorRouteImport
      parentRoute: typeof HomeRouteRoute
    }
    '/microdados/': {
      id: '/microdados/'
      path: '/'
      fullPath: '/microdados/'
      preLoaderRoute: typeof MicrodadosIndexRouteImport
      parentRoute: typeof MicrodadosRouteRoute
    }
    '/microdados/analise-detalhada': {
      id: '/microdados/analise-detalhada'
      path: '/analise-detalhada'
      fullPath: '/microdados/analise-detalhada'
      preLoaderRoute: typeof MicrodadosAnaliseDetalhadaRouteImport
      parentRoute: typeof MicrodadosRouteRoute
    }
    '/microdados/pdf-preview': {
      id: '/microdados/pdf-preview'
      path: '/pdf-preview'
      fullPath: '/microdados/pdf-preview'
      preLoaderRoute: typeof MicrodadosPdfPreviewRouteImport
      parentRoute: typeof MicrodadosRouteRoute
    }
    '/pagamento/': {
      id: '/pagamento/'
      path: '/pagamento'
      fullPath: '/pagamento/'
      preLoaderRoute: typeof PagamentoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/redacoes/': {
      id: '/redacoes/'
      path: '/'
      fullPath: '/redacoes/'
      preLoaderRoute: typeof RedacoesIndexRouteImport
      parentRoute: typeof RedacoesRouteRoute
    }
    '/redacoes/trilha-de-aprendizagem': {
      id: '/redacoes/trilha-de-aprendizagem'
      path: '/trilha-de-aprendizagem'
      fullPath: '/redacoes/trilha-de-aprendizagem'
      preLoaderRoute: typeof RedacoesTrilhaDeAprendizagemRouteImport
      parentRoute: typeof RedacoesRouteRoute
    }
    '/resultados/': {
      id: '/resultados/'
      path: '/resultados'
      fullPath: '/resultados/'
      preLoaderRoute: typeof ResultadosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tarefa/nova': {
      id: '/tarefa/nova'
      path: '/tarefa/nova'
      fullPath: '/tarefa/nova'
      preLoaderRoute: typeof TarefaNovaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trilha-de-aprendizagem/$id': {
      id: '/trilha-de-aprendizagem/$id'
      path: '/$id'
      fullPath: '/trilha-de-aprendizagem/$id'
      preLoaderRoute: typeof TrilhaDeAprendizagemIdRouteImport
      parentRoute: typeof TrilhaDeAprendizagemRouteRoute
    }
    '/trilha-de-aprendizagem/nova': {
      id: '/trilha-de-aprendizagem/nova'
      path: '/nova'
      fullPath: '/trilha-de-aprendizagem/nova'
      preLoaderRoute: typeof TrilhaDeAprendizagemNovaRouteImport
      parentRoute: typeof TrilhaDeAprendizagemRouteRoute
    }
    '/banco-de-temas/colecoes_/$id': {
      id: '/banco-de-temas/colecoes_/$id'
      path: '/colecoes/$id'
      fullPath: '/banco-de-temas/colecoes/$id'
      preLoaderRoute: typeof BancoDeTemasColecoesIdRouteImport
      parentRoute: typeof BancoDeTemasRouteRoute
    }
    '/resultados/aluno/': {
      id: '/resultados/aluno/'
      path: '/resultados/aluno'
      fullPath: '/resultados/aluno/'
      preLoaderRoute: typeof ResultadosAlunoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tarefa/$idTarefa/visao-geral': {
      id: '/tarefa/$idTarefa/visao-geral'
      path: '/tarefa/$idTarefa/visao-geral'
      fullPath: '/tarefa/$idTarefa/visao-geral'
      preLoaderRoute: typeof TarefaIdTarefaVisaoGeralRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trilha-de-aprendizagem/editar/$id': {
      id: '/trilha-de-aprendizagem/editar/$id'
      path: '/editar/$id'
      fullPath: '/trilha-de-aprendizagem/editar/$id'
      preLoaderRoute: typeof TrilhaDeAprendizagemEditarIdRouteImport
      parentRoute: typeof TrilhaDeAprendizagemRouteRoute
    }
  }
}

interface BancoDeTemasRouteRouteChildren {
  BancoDeTemasColecoesRoute: typeof BancoDeTemasColecoesRoute
  BancoDeTemasMeusTemasRoute: typeof BancoDeTemasMeusTemasRoute
  BancoDeTemasSalvosRoute: typeof BancoDeTemasSalvosRoute
  BancoDeTemasIndexRoute: typeof BancoDeTemasIndexRoute
  BancoDeTemasColecoesIdRoute: typeof BancoDeTemasColecoesIdRoute
}

const BancoDeTemasRouteRouteChildren: BancoDeTemasRouteRouteChildren = {
  BancoDeTemasColecoesRoute: BancoDeTemasColecoesRoute,
  BancoDeTemasMeusTemasRoute: BancoDeTemasMeusTemasRoute,
  BancoDeTemasSalvosRoute: BancoDeTemasSalvosRoute,
  BancoDeTemasIndexRoute: BancoDeTemasIndexRoute,
  BancoDeTemasColecoesIdRoute: BancoDeTemasColecoesIdRoute,
}

const BancoDeTemasRouteRouteWithChildren =
  BancoDeTemasRouteRoute._addFileChildren(BancoDeTemasRouteRouteChildren)

interface HomeRouteRouteChildren {
  HomeCoordenadorRoute: typeof HomeCoordenadorRoute
}

const HomeRouteRouteChildren: HomeRouteRouteChildren = {
  HomeCoordenadorRoute: HomeCoordenadorRoute,
}

const HomeRouteRouteWithChildren = HomeRouteRoute._addFileChildren(
  HomeRouteRouteChildren,
)

interface MicrodadosRouteRouteChildren {
  MicrodadosAnaliseDetalhadaRoute: typeof MicrodadosAnaliseDetalhadaRoute
  MicrodadosPdfPreviewRoute: typeof MicrodadosPdfPreviewRoute
  MicrodadosIndexRoute: typeof MicrodadosIndexRoute
}

const MicrodadosRouteRouteChildren: MicrodadosRouteRouteChildren = {
  MicrodadosAnaliseDetalhadaRoute: MicrodadosAnaliseDetalhadaRoute,
  MicrodadosPdfPreviewRoute: MicrodadosPdfPreviewRoute,
  MicrodadosIndexRoute: MicrodadosIndexRoute,
}

const MicrodadosRouteRouteWithChildren = MicrodadosRouteRoute._addFileChildren(
  MicrodadosRouteRouteChildren,
)

interface RedacoesRouteRouteChildren {
  RedacoesTrilhaDeAprendizagemRoute: typeof RedacoesTrilhaDeAprendizagemRoute
  RedacoesIndexRoute: typeof RedacoesIndexRoute
}

const RedacoesRouteRouteChildren: RedacoesRouteRouteChildren = {
  RedacoesTrilhaDeAprendizagemRoute: RedacoesTrilhaDeAprendizagemRoute,
  RedacoesIndexRoute: RedacoesIndexRoute,
}

const RedacoesRouteRouteWithChildren = RedacoesRouteRoute._addFileChildren(
  RedacoesRouteRouteChildren,
)

interface TrilhaDeAprendizagemRouteRouteChildren {
  TrilhaDeAprendizagemIdRoute: typeof TrilhaDeAprendizagemIdRoute
  TrilhaDeAprendizagemNovaRoute: typeof TrilhaDeAprendizagemNovaRoute
  TrilhaDeAprendizagemEditarIdRoute: typeof TrilhaDeAprendizagemEditarIdRoute
}

const TrilhaDeAprendizagemRouteRouteChildren: TrilhaDeAprendizagemRouteRouteChildren =
  {
    TrilhaDeAprendizagemIdRoute: TrilhaDeAprendizagemIdRoute,
    TrilhaDeAprendizagemNovaRoute: TrilhaDeAprendizagemNovaRoute,
    TrilhaDeAprendizagemEditarIdRoute: TrilhaDeAprendizagemEditarIdRoute,
  }

const TrilhaDeAprendizagemRouteRouteWithChildren =
  TrilhaDeAprendizagemRouteRoute._addFileChildren(
    TrilhaDeAprendizagemRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BancoDeTemasRouteRoute: BancoDeTemasRouteRouteWithChildren,
  HomeRouteRoute: HomeRouteRouteWithChildren,
  MicrodadosRouteRoute: MicrodadosRouteRouteWithChildren,
  RedacoesRouteRoute: RedacoesRouteRouteWithChildren,
  TrilhaDeAprendizagemRouteRoute: TrilhaDeAprendizagemRouteRouteWithChildren,
  RednewsRoute: RednewsRoute,
  UnauthorizedRoute: UnauthorizedRoute,
  TarefaNovaRoute: TarefaNovaRoute,
  PagamentoIndexRoute: PagamentoIndexRoute,
  ResultadosIndexRoute: ResultadosIndexRoute,
  TarefaIdTarefaVisaoGeralRoute: TarefaIdTarefaVisaoGeralRoute,
  ResultadosAlunoIndexRoute: ResultadosAlunoIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
